export const CHECK = 'CHECK'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const CHANGE_SERVER = 'CHANGE_SERVER'
export const CHANGE_TOKEN = 'CHANGE_TOKEN'
export const CHANGE_LOGIN = 'CHANGE_LOGIN'
export const CHANGE_COMPANY = 'CHANGE_COMPANY'
export const CLEAR = 'CLEAR'
export const TOKEN_REFRESH = 'TOKEN_REFRESH'

export default {
  CHECK,
  LOGIN,
  TOKEN_REFRESH,
  LOGOUT,
  CHANGE_SERVER,
  CHANGE_TOKEN,
  CHANGE_LOGIN,
  CHANGE_COMPANY,
  CLEAR
}
